export default __webpack_public_path__ + "static/media/ph_map-pin-fill.ef36b8d2.svg";